"use strict";

exports.__esModule = true;
exports["default"] = exports.MapStyles = void 0;
/* eslint-disable */
var MapStyles = [{
  featureType: 'administrative',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#686D71'
  }]
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    color: '#F6F6F6'
  }]
}, {
  featureType: 'poi',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road',
  elementType: 'all',
  stylers: [{
    saturation: -100
  }, {
    lightness: 45
  }]
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'simplified'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    color: '#99d4ec'
  }, {
    visibility: 'on'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#99d4ec'
  }, {
    gamma: '1.00'
  }]
}];
exports.MapStyles = MapStyles;
var _default = MapStyles;
/* eslint-enable */
exports["default"] = _default;